export default {
  part_number: '',
  stencils_border: '0',
  quantities: ['1'],
};
